goog.provide('el8.appchart.dialog.addProblemDetailDialog');

goog.require('el8.uiwidget.QuickSelectDialog');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.appchart.dialog.addEditProblem');


el8.appchart.dialog.addProblemDetailDialog = (function() {

    var module = {};

    module.show = function(text) {
        var that = new el8.uiwidget.QuickSelectDialog({
            title: 'Add as Synopsis to Existing Problem?',
            callbackFn: function(index) {
                var selected = el8.ptdata.ptProblems.getAllActive()[index];
                el8.appchart.dialog.addEditProblem.show({
                    problem: selected,
                    details: text
                });
                that.destroy();
            },
            list: el8.ptdata.ptProblems.getAllActive().map(function(p) {
                return p.getDescription();
            })
        });
        that.show();
    };

    return module;

})();

